<template>
    <div class="topic-album">
        <div class="topic-photos">
            <div class="gallery-item" v-for="(item, index) in album" :key="index">
                <img
                class="gallery-item__poster"
                :src="item.medium"
                @click="browse(index)"/>
                <img class="gallery-item__btn"
                src="@/assets/icons/circle-xmark-duotone.svg"
                mode="aspectFit" @click="remove(index)"/>
            </div>
            <div class="gallery-item" v-for="(item, index) in queue" :key="index">
                <div class="gallery-item__loading" :style="{height: `${100 - item.progress}%`}"></div>
                <img
                class="gallery-item__poster"
                :src="item.result ? item.result.image.medium : item.path"/>
                <!-- <div class="gallery-item__progress" v-if="item.progress && item.progress < 100">
                    <progress percent="{{item.progress}}" color="#08979C" stroke-width="5"/>
                </div> -->
            </div>
            <!-- <div class="~gallery-item" bindtap="more" wx:if="{{album.length + queue.length < 9}}">
                <image class="~gallery-item__icon"
                src="/assets/icons/plus-sharp-light-normal.svg" mode="aspectFit"></image>
            </div> -->
        </div>
    </div>
</template>

<script>
    import swiper from '@/mixins/swiper'

    export default {
        props: ['album', 'queue'],
        mixins: [swiper],
        methods: {
            remove (index) {
                this.album.splice(index, 1)
            },
            browse (index) {
                this.view(index, this.album.map(photo => {
                    return {
                        src: photo.src,
                        width: photo.width,
                        height: photo.height
                    }
                }))
            }
        }
    }
</script>

<style lang="less" scoped>
    .topic-album {
        margin-top: -10px;
        margin-bottom: 10px;
        .topic-photos, .topic-videos {
            overflow: hidden;
        }
    }
    .gallery-item__loading {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background-color: #333;
        opacity: .5;
        z-index: 2;
    }
</style>


